<div
  style="display: inline-flex; flex-direction: column; gap: 4px; width: 100%"
>
  <div #DropArea class="drop-area" [class.disabled]="disabled">
    <div class="drop-content" [class.vertical]="vertical">
      <img src="/assets/img/upload.png" />
      <h3 class="!font-normal">
        <b>Drag and drop</b> your files here<br />
        or <a><b>choose a file</b></a> to upload
      </h3>
    </div>
    <input
      type="file"
      #FileInput
      style="display: none"
      [attr.accept]="SupportedFileTypes"
      multiple
    />
  </div>

  <div
    class="inline-flex justify-between w-full text-[#888] text-xs leading-4 h-5"
  >
    <div nz-tooltip [nzTooltipTitle]="SupportedFileTypes | join: ' '">
      Multiple formats supported
    </div>
    <div>Max. size: {{ maxFileSizeInBytes | bytesToSize }}</div>
  </div>
</div>
